import { render } from "./taskView.vue?vue&type=template&id=cb228228"
import script from "./taskView.vue?vue&type=script&lang=js"
export * from "./taskView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__